import React from "react";
import "./AdminPage.css"
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { createTheme, ThemeProvider } from "@mui/system";
import Message from "./Message";
import axios from "axios";

class MessagesPage extends React.Component {
    messages=[
        ["0","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","اوکی"],
        ["1","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","مرسی"],
        ["2","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["3","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصهثبخحتثخحبتخحثصب ثصحختبخحثصتبخحثصتبخحثتصب حصخثتبخحضثصبخحتثخبحتصحثبپخحصث ب حخثصتبحثصتحختقبخحثصتبخحتخحصثپزتصحختث صحثخهتبخحثصتبخحتثبخحتصیبهحجحصثوقپخهصثابجگشهحخقبحصثندبت ثصخثصبخثصپهحخصخثتبکتشهخثصبتخحشپمخثصتبخدلعهخقثلاصتگشبصهبتخح حتثصبحخ خثصتحبتخهصثابحهتصکثب هخبخهصثتبدهصختبحثصپبزخاثصتبخنثمصب تب"],
        ["4","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["5","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["6","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["7","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["8","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["9","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["10","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["11","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["12","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["13","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"],
        ["14","خایخبزخصهدب صثبتخحصثبخحتصثخحبت صحخثتبحخثصتبخحتثصخحبت حخصثتبخحپصخحزیپخحصثتیخحصثبی حثدتبتخحصتیخحزپخحثصتیخحث حخصثدتبخحصتیخحزپصخحیزتخحثصی صثدتیخحزصثخحزخثصحنبپخحثصی خحصتیحخصثپخحیپثصخحی حخثصدبخحثصپبییخحثصپبمحکمثصپیزخحپث حدثصحبپزخحصثبپثصپبزخحصحث","خصثستیبحتصثحبتثصب"]
    ];

    constructor(props) {
        super(props);
        this.state = {
            currentPage:1,
            startMessage:0,
            endMessage:5,
        };


        
    }

    async componentDidMount() {
        axios.get(`http://45.159.197.151:8081/comments/get-all-comments/`)
          .then(res => {
            const commentss=res.data;
            //console.log("comments:"+JSON.stringify(comments.result));
            this.setState({
                comments: commentss
            })
          })
          
          
      }
    render() {
        
        console.log("State: "+JSON.stringify(this.state.comments))
        const handleMessageChange = (event,value) => {
            this.setState({
                currentPage:value,
                startMessage:(value-1)*6,
                endMessage:(value)*6 -1
            })
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          };
        try{
        return <div>
            {
                 this.state.comments.result.slice(this.state.startMessage,this.state.endMessage).map((anObjectMapped, index) => {
                    return (
                        <Message reply={('response' in anObjectMapped)?  anObjectMapped.response: "پاسخی یافت نشد!" } number={index+1} senderName={anObjectMapped.reporter} message={anObjectMapped.report}/>
                    );
                })
            }
            
            <div className="row">
                <Stack spacing={2} className="AdminPagination">
                    <Pagination onChange={handleMessageChange} count={parseInt(this.state.comments.length/6 + 1)} color="success" />
                </Stack>
            </div>
            
        </div>
        }
        catch{
            console.log("mmd");
        }
    }
    
  }

export default MessagesPage